<template>
  <div v-if="faqs && faqs.length">
    <!-- Header -->
    <div class="text-center mt-14 mb-6">
      <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
        Frequently Asked Questions
      </h2>
    </div>

    <!-- FAQ List -->
    <div class="space-y-2 sm:space-y-3">
      <details
        v-for="(faq, i) in faqs"
        :key="i"
        open
        class="group rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition hover:shadow-md"
      >
        <summary class="flex cursor-pointer list-none items-center justify-between">
          <h3
            class="text-base sm:text-lg font-semibold text-gray-900 group-open:text-red-600"
          >
            {{ faq.question }}
          </h3>

          <span
            class="ml-4 flex h-8 w-8 items-center justify-center rounded-full bg-red-50 text-red-600 transition group-open:rotate-180"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </span>
        </summary>

        <div
          class="faq-answer mt-4 border-l-4 border-red-600 pl-4 text-gray-600 text-justify"
          v-html="faq.answer"
        ></div>
      </details>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      faqs: {
        type: Array,
        required: true,
        default: () => []
      }
    }
  }
</script>

<style>
.faq-answer p {
  margin-bottom: 0.75rem;
  line-height: 1.7;
}

.faq-answer p:last-child {
  margin-bottom: 0;
}

.faq-answer ul {
  list-style: disc;
  margin-left: 1.25rem;
  margin-bottom: 0.75rem;
}

.faq-answer li {
  margin-bottom: 0.35rem;
  line-height: 1.6;
}

.faq-answer strong {
  color: #1f2937;
}
</style>
